/* Progressive enhancement only. Crawlable HTML is the directory and guide source. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.init(root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var CODE_PATTERN = /^[PBCU][0-3][0-9A-F]{3}$/;
  function normalizeCode(value) { return String(value || '').trim().toUpperCase(); }
  function isValidCode(value) { return CODE_PATTERN.test(normalizeCode(value)); }
  function safeUrl(value, origin, baseHref) {
    try { var url = new URL(value, baseHref || origin); return url.origin === origin && /^https?:$/.test(url.protocol) ? url : null; } catch (_) { return null; }
  }
  function analyticsAllowed(win) {
    try { return !!(win.Shopify && win.Shopify.customerPrivacy && win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true); } catch (_) { return false; }
  }
  function emit(win, name, data) {
    if (!analyticsAllowed(win)) return;
    // A verified existing analytics adapter may consume this event. No pixel is installed here.
    win.document.dispatchEvent(new win.CustomEvent('uth:editorial-event', { detail: Object.assign({ name: name }, data) }));
  }
  function collectPage(doc, origin, baseHref) {
    var base = baseHref || doc.URL || doc.ownerDocument && doc.ownerDocument.URL || origin;
    var records = [];
    doc.querySelectorAll('[data-code-directory] a[data-code]').forEach(function (link) {
      var code = normalizeCode(link.getAttribute('data-code'));
      var url = safeUrl(link.getAttribute('href'), origin, base);
      var id = link.getAttribute('data-content-id') || '';
      if (CODE_PATTERN.test(code) && url && /^uth-dtc-[a-z0-9-]+$/.test(id)) records.push({ code: code, contentId: id, title: link.getAttribute('data-title') || code, url: url.href });
    });
    var pages = [];
    doc.querySelectorAll('[data-code-next], [data-code-previous]').forEach(function (link) {
      var url = safeUrl(link.getAttribute('href'), origin, base);
      if (url) { url.hash = ''; pages.push(url.href); }
    });
    return { records: records, pages: pages };
  }
  function init(win) {
    var doc = win.document;
    function boot() {
      var lookup = doc.querySelector('[data-uth-code-lookup]');
      if (lookup && !lookup.dataset.uthInitialized) {
        lookup.dataset.uthInitialized = 'true';
        var form = lookup.querySelector('[data-code-form]');
        var input = lookup.querySelector('[data-code-input]');
        var result = lookup.querySelector('[data-code-result]');
        var origin = win.location.origin;
        var page = collectPage(lookup, origin);
        var index = new Map(page.records.map(function (record) { return [record.code, record]; }));
        var currentUrl = new URL(win.location.href); currentUrl.hash = '';
        var seen = new Set([currentUrl.href]);
        var queue = page.pages.slice();
        var complete = queue.length === 0;
        var loading;
        var requestId = 0;
        function loadIndex() {
          if (complete) return Promise.resolve(true);
          if (loading) return loading;
          loading = (async function () {
            try {
              // Shopify Liquid pagination reaches at most 25,000 entries. Beyond this,
              // publish a reviewed build-time index rather than silently truncating search.
              while (queue.length) {
                var next = queue.shift();
                if (seen.has(next)) continue;
                if (seen.size >= 100) throw new Error('directory-limit');
                seen.add(next);
                var nextUrl = safeUrl(next, origin);
                if (!nextUrl || nextUrl.pathname !== currentUrl.pathname) throw new Error('invalid-directory-url');
                var controller = new win.AbortController();
                var timeout = win.setTimeout(function () { controller.abort(); }, 10000);
                var response;
                try { response = await win.fetch(nextUrl.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } }); }
                finally { win.clearTimeout(timeout); }
                if (!response.ok || response.redirected && new URL(response.url).origin !== origin) throw new Error('directory-request');
                var parsed = new win.DOMParser().parseFromString(await response.text(), 'text/html');
                if (!parsed.querySelector('[data-uth-code-lookup]')) throw new Error('directory-response');
                var fetched = collectPage(parsed, origin, nextUrl.href);
                fetched.records.forEach(function (record) { index.set(record.code, record); });
                fetched.pages.forEach(function (url) { if (!seen.has(url)) queue.push(url); });
              }
              complete = true;
              return true;
            } catch (_) { return false; }
          })();
          return loading;
        }
        function message(text) { result.replaceChildren(doc.createTextNode(text)); }
        form.addEventListener('submit', async function (event) {
          event.preventDefault();
          var ownRequest = ++requestId;
          var code = normalizeCode(input.value);
          input.setAttribute('aria-invalid', CODE_PATTERN.test(code) ? 'false' : 'true');
          if (!CODE_PATTERN.test(code)) {
            message('Enter a five-character trouble code such as P0300. Use P, B, C or U, followed by 0–3 and three numbers or letters A–F.');
            emit(win, 'code_search_malformed', { content_id: 'uth-code-lookup', result: 'malformed' });
            return;
          }
          input.value = code;
          var found = index.get(code);
          if (!found && !complete) { message('Checking the full code library…'); await loadIndex(); }
          if (ownRequest !== requestId) return;
          found = index.get(code);
          if (found) {
            emit(win, 'code_search', { code: code, content_id: 'uth-code-lookup', result: 'found' });
            var link = doc.createElement('a'); link.href = found.url; link.textContent = 'Open ' + found.title; link.className = 'uth-editorial__text-link';
            result.replaceChildren(doc.createTextNode('Guide found. '), link);
          } else if (!complete) {
            message('We could not check every directory page. This does not tell us whether your code is covered. Browse the directory links below or try again later.');
            emit(win, 'code_search', { code: code, content_id: 'uth-code-lookup', result: 'index_unavailable' });
          } else {
            message(code + ' has a valid code format, but this library does not cover it yet. It may be manufacturer-specific. Check the vehicle’s service information or ask a qualified technician; a missing guide does not mean the code does not exist.');
            emit(win, 'code_search', { code: code, content_id: 'uth-code-lookup', result: 'not_covered' });
            emit(win, 'code_search_no_result', { code: code, content_id: 'uth-code-lookup', result: 'not_covered' });
          }
        });
      }
      doc.querySelectorAll('[data-copy-code]').forEach(function (button) {
        if (button.dataset.uthInitialized) return;
        button.dataset.uthInitialized = 'true';
        button.addEventListener('click', async function () {
          var code = normalizeCode(button.getAttribute('data-copy-code'));
          var status = button.parentElement.querySelector('[data-copy-status]');
          if (!CODE_PATTERN.test(code) || !status) return;
          try { await win.navigator.clipboard.writeText(code); status.textContent = 'Copied ' + code + '.'; }
          catch (_) {
            var badge = button.parentElement.querySelector('.uth-code-guide__badge');
            if (badge && win.getSelection) { var range = doc.createRange(); range.selectNodeContents(badge); var selection = win.getSelection(); if (selection) { selection.removeAllRanges(); selection.addRange(range); } }
            status.textContent = 'Automatic copy is unavailable. Select and copy ' + code + ' manually.';
          }
        });
      });
      if (!doc.documentElement.dataset.uthEditorialClicks) {
        doc.documentElement.dataset.uthEditorialClicks = 'true';
        doc.addEventListener('click', function (event) {
          var link = event.target.closest && event.target.closest('[data-editorial-action]');
          if (!link) return;
          var action = link.getAttribute('data-editorial-action');
          if (['app_link_click', 'compatibility_click', 'scanner_product_click'].indexOf(action) < 0) return;
          var container = link.closest('[data-content-id], [data-uth-content-id]');
          emit(win, action, { content_id: link.getAttribute('data-content-id') || (container && (container.getAttribute('data-content-id') || container.getAttribute('data-uth-content-id'))) || 'uth-editorial' });
        });
      }
      doc.querySelectorAll('[data-uth-code-guide]').forEach(function (article) {
        function view() {
          if (article.dataset.uthViewSent || !analyticsAllowed(win)) return;
          article.dataset.uthViewSent = 'true';
          var data = { content_id: article.getAttribute('data-content-id') || article.getAttribute('data-uth-content-id') || 'uth-editorial' };
          var code = normalizeCode(article.getAttribute('data-code')); if (!CODE_PATTERN.test(code)) return; data.code = code;
          emit(win, 'guide_view', data);
        }
        view(); doc.addEventListener('visitorConsentCollected', view);
      });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  }
  return { normalizeCode: normalizeCode, isValidCode: isValidCode, safeUrl: safeUrl, collectPage: collectPage, analyticsAllowed: analyticsAllowed, init: init };
});
